import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Box } from '@mui/material';
import { ChannelDetail, VideoDetail, SearchFeed, Navbar, Feed } from './components';

function App() {
  return (
  <div>
   <BrowserRouter>
    {/* <Box style={{backgroundColor:"#000"}}> */}
    <Box style={{color:"black"}}>
    <Navbar />
      <Routes>
        <Route exact path='/' element={<Feed />} />
        <Route path='/video/:id' element={<VideoDetail />} />
        <Route path='/channel/:id' element={<ChannelDetail />} />
        <Route path='/search/:searchTerm' element={<SearchFeed />} />
      </Routes>
    </Box>
   </BrowserRouter> 
  </div>
  );
}

export default App;
